




























import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api';
import BudgetCoupon from '@tt4b/ttam-assets/src/svgs/budget-coupon.svg';
import { useCoupon, useStdCampaignIs } from '@tt4b/ttam-hooks';
import { CampaignFormData } from '@tt4b/ttam-enums';
const name = 'ttam-budget-coupon';

export default defineComponent({
  name,
  components: {
    BudgetCoupon,
  },
  props: {
    campaignData: Object as PropType<CampaignFormData>,
    shopId: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const { campaignData } = toRefs(props);
    const { showBudgetCoupon, couponMsg, isLoadBudgetCoupon, budgetCouponInfo } = useCoupon();
    const { isProductSalesCloseLoop } = useStdCampaignIs({
      campaignFormData: campaignData,
    });
    const couponId = computed(() => budgetCouponInfo.value?.coupon_id || '');
    return {
      name,
      showBudgetCoupon,
      couponMsg,
      isProductSalesCloseLoop,
      isLoadBudgetCoupon,
      budgetCouponInfo,
      couponId,
    };
  },
});
